import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import React, { useEffect, useState } from 'react';
import { useObservable } from 'react-use-observable';
import { warningsFactory } from 'v2/services/warning';

import NoDangerouslyHTML from '../NoDangerouslyHTML';

const GlobalWarning = () => {
  useEffect(() => warningsFactory.loadGlobalWarning(), []);
  const [warning] = useObservable(() => warningsFactory.getWarning(), []);
  const [local, setLocal] = useState<boolean>(true);
  const storage = localStorage.getItem(warning?.name);

  useEffect(() => {
    setLocal(!!storage);
  }, [storage]);

  const closeAlert = () => {
    localStorage.setItem(warning.name, 'true');
    setLocal(true);
  };

  if (!warning?.enabled) return null;

  if (local) return null;

  return (
    <>
      <Alert
        severity='warning'
        action={
          <Button color='primary' variant='outlined' onClick={closeAlert} aria-label='fechar'>
            Entendi
          </Button>
        }
      >
        <AlertTitle>{warning.label} </AlertTitle>
        <NoDangerouslyHTML html={warning.hint} />
      </Alert>
      <div className='m16' />
    </>
  );
};

export default GlobalWarning;
